import c from "./lib/createApi";

export default {
  log: c("POST", "/v1/trace/log/add", true), 
  getAllLog: c("GET", "/v1/trace/getAllLog", false), 
  popularData: c("GET", "/v1/trace/popularData", true), 
};
